module.exports = __webpack_public_path__ + "img/robo-klaus-2.b7db98fe.png";